export default __webpack_public_path__ + "static/media/Foresty_bg.89cc08f6.jpg";